export default __webpack_public_path__ + "static/media/houston169.6c31c494.jpg";